import angular from "angular";

import "oclazyload";
import AdminRootModule from "./modules/root/admin-root.module";
import AdminBicyclesModule from "./modules/bicycles/admin-bicycles.module";
import AdminBookingsModule from "./modules/bookings/admin-bookings.module";
import AdminOrganisationsModule from "./modules/organisations/admin-organisations.module";
import AdminProfileModule from "./modules/profile/admin-profile.module";
import AdminServicesModule from "./modules/services/admin-services.module";
import AdminDistributorsModule from "./modules/definitions/admin-definitions.module";
import AdminUsersModule from "./modules/users/admin-users.module";
import AdminAnalyticsModule from "./modules/analytics/admin-analytics.module";
import AdminNotificationsModule from "./modules/notifications/admin-notifications.module";
import AdminServiceProvidersModule from "./modules/service-providers/admin-service-providers.module";

export default angular
  .module("vt-admin", [
    AdminRootModule.name,
    AdminBicyclesModule.name,
    AdminBookingsModule.name,
    AdminDistributorsModule.name,
    AdminOrganisationsModule.name,
    AdminProfileModule.name,
    AdminServicesModule.name,
    AdminDistributorsModule.name,
    AdminUsersModule.name,
    AdminAnalyticsModule.name,
    AdminNotificationsModule.name,
    AdminServiceProvidersModule.name
  ]);
